export enum LearningContentType {
  AUDIO = 0,
  VIDEO = 1,
}

export enum ActionType {
  LOGIN = 1,
  AI_CHAT = 2,
  VIDEO = 3,
  MISSION_COMPLETE = 4,
  TASK_COMPLETE = 5,
  TEST_PARTICIPATION = 6,
  LEVEL_UP = 7,
}

export enum UserRole {
  ADMIN = 0,
  USER = 1,
  MANAGER = 2,
}

export enum CourseStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum UserEngagementStatus {
  NOT_LOGGED_IN = 0,
  LOGGED_IN_ONLY = 1,
  WATCHING = 2,
  WATCHED = 3,
}
